import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { useContext, useEffect, useState } from "react";
import { APIContext, DialogAction } from "../../Contexts/APIContext";
import Line from "../../Utilities/Line";
import TableContainer from "@mui/material/TableContainer";
import ResponsiveTable from "../../Utilities/ResponsiveTable";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Button from "@mui/material/Button";
import { AuthContext } from "../../Authorisation/AuthContext";
import { UserViewModel } from "../../Management/Organisations/ViewModels/OrganisationVieModel";
import Dialog from "@mui/material/Dialog";
import { FormContainer, useForm } from "react-hook-form-mui";
import CreateEditAdminViewModel from "./ViewModels/CreateEditAdminViewModel";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import InputLabel from "@mui/material/InputLabel";
import ValidatedTextField from "../../Utilities/Forms/ValidatedTextField";
import DialogActions from "@mui/material/DialogActions";


export default function AdminUsertable() {
    const { get, post, showMessage, openDialog } = useContext(APIContext);
    const { userDetails } = useContext(AuthContext);
    const [addEditId, setAddEditId] = useState<string | null>(null);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [menuUser, setMenuUser] = useState<UserViewModel | null>(null);
    const [admins, setAdmins] = useState<UserViewModel[]>([]);
    const open = Boolean(anchorEl);

    useEffect(() => {
        refresh();
    }, []);

    const formContext = useForm<CreateEditAdminViewModel>({
        defaultValues: new CreateEditAdminViewModel(),
    });
    const { reset } = formContext;

    const refresh = () => {
        get('adminuser', 'GetAdminUsers', setAdmins);
    };
    const closeDialogs = () => {
        refresh();
        setAddEditId(null);
        reset(new CreateEditAdminViewModel())
    };

    const handleMenuOpen = (event: any, user: any) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setMenuUser(user);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setMenuUser(null);
    };

    const handleToggleArchive = async (
        event: any,
        user: UserViewModel,
    ) => {
        event.stopPropagation();
        handleMenuClose();
        openDialog(<Typography>"Are you sure you want to remove this user?"</Typography>, [
            new DialogAction("Confirm", () => {
                get(
                    "AdminUser",
                    `UpdateArchiveStatus?id=${user.id}`,
                    (success: any) => {
                        showMessage("success", "User status has been updated");
                        refresh();
                    },
                );
            }
            )]);

    };

    const handleResetPassword = async (
        event: any,
        user: UserViewModel,
    ) => {
        event.stopPropagation();
        handleMenuClose();
        const action = `SendResetPasswordEmail?email=${encodeURIComponent(user.email)}`;
        await get("AdminUser", action, (success: any) => {
            showMessage(
                "success",
                "Password reset email sent",
            );
        });
    };

    const onSucess = () => {
        closeDialogs();
        refresh();
        reset(new CreateEditAdminViewModel())
        showMessage('success', "User added successfully");
    }

    const submit = async (form: any) => {
        await post("AdminUser", `CreateAdminUser`, form, onSucess);
    }

    return (
        <Grid container>
            <Grid container size={12}>
                <Grid>
                    <Typography variant="h6">TRICS Administrators</Typography>
                </Grid>
                <Grid>
                    <Button size={'small'} variant="contained" onClick={() => setAddEditId('')}>
                        Add New Admin
                    </Button>
                </Grid>
            </Grid>
            <Line />
            <TableContainer sx={{ width: "100%", maxHeight: 200 }}>
                <ResponsiveTable stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ width: "100%" }}>
                        {admins !== null &&
                            admins.map((row) =>
                                <TableRow key={row.name} hover sx={{ cursor: "pointer" }}>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                    <TableCell align='right'>
                                        <Grid container spacing={1} justifyContent='flex-end' alignItems="center" sx={{ flexWrap: 'nowrap' }}>
                                            <Grid>
                                                <IconButton size="small" onClick={(event) => handleMenuOpen(event, row)} aria-label="Staff actions dropdown">
                                                    <MoreVertIcon />
                                                </IconButton>

                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>)
                        }
                    </TableBody>
                </ResponsiveTable>
                <Menu
                    open={open}
                    onClose={handleMenuClose}
                    anchorEl={anchorEl}
                >
                    {menuUser?.email !== userDetails?.userEmail &&
                        <MenuItem
                            onClick={(event) => menuUser && handleToggleArchive(event, menuUser)}
                        >
                            {"Remove"}
                        </MenuItem>
                    }
                    {menuUser?.emailConfirmed &&
                        <MenuItem
                            onClick={(event) => menuUser && handleResetPassword(event, menuUser)}
                        >
                            Reset Password
                        </MenuItem>
                    }
                </Menu>
                <Dialog
                    open={addEditId != null}
                    onClose={closeDialogs}
                    maxWidth="xs"
                    fullWidth
                >
                    <FormContainer
                        onSuccess={submit}
                        formContext={formContext}
                    >
                        <DialogTitle>Add New Admin</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12 }}>
                                    <InputLabel shrink>Email</InputLabel>
                                    <ValidatedTextField name="email" />
                                </Grid>
                            </Grid>
                            <DialogActions>
                                <Button onClick={() => closeDialogs()}>Cancel</Button>
                                <Button type="submit">Add</Button>
                            </DialogActions>
                        </DialogContent>
                    </FormContainer>
                </Dialog >
            </TableContainer>
        </Grid>
    );
}
